import get from 'lodash/get';
import * as types from './constants';
const defaultState = {
  loading: false,
  error: null,
  activeStep: 0,
  application: {},
  applicationType: '',
  documents: [],
  poaSource: 'ADGM_Court',
  fetchedPOADetails: {},
  poaDetailsFormFields: {},
  poaContractDetails: {},
  multiProperties: [],
  poaModalFields: {},
  isDBDocumentsApiCalled: false,
  lookups: {
    poaTypesLookup: [],
    poaClassificationLookup: [],
    countries: [],
    cities: [],
  },
  firstParty: [],
  secondParty: [],
};
export default function PowerOfAttorneyReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.REGISTER_POA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.REGISTER_POA_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.RESET_REGISTER_POA_REDUCER:
      return defaultState;

    case types.FETCH_APPLICATION_REGISTER_POA_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        applicationType: get(action.payload, 'applicationType', ''),
        poaDetailsFormFields: get(action.payload, 'poaDetailsFormFields', {}),
        firstParty: get(action.payload, 'firstParty', {}),
        secondParty: get(action.payload, 'secondParty', {}),
        contractDetails: get(action.payload, 'contractDetails', {}),
        poaSource: get(action.payload, 'poaSource', 'ADGM_Court'),
        fetchedPOADetails: {
          ...state.fetchedPOADetails,
          ...(action.payload.fetchedPOANumber && { eid: action.payload.fetchedPOANumber }),
        },
        permissions: get(action.payload, 'permissions', {}),
      };
    case types.FETCH_DOCUMENTS_REGISTER_POA_SUCCESS:
      return {
        ...state,
        loading: false,
        documents: get(action.payload, 'documents', []),
      };

    case types.INITIATE_REGISTER_POA_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
      };

    case types.DOWNLOAD_DOCUMENT_REGISTER_POA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.REGISTER_POA_CANCEL_APPLICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }

    case types.REGISTER_POA_CLEAR_DATA:
      return defaultState;

    case types.REGISTER_POA_DOCUMENT_CHANGE_STATE:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', state.documents),
        isDBDocumentsApiCalled: get(action.payload, 'isDBDocumentsApiCalled', state.isDBDocumentsApiCalled),
        dbExistingDocuments: get(action.payload, 'dbExistingDocuments', state.dbExistingDocuments),
      };

    case types.ADD_TO_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.CHANGE_REGISTER_POA_STEP:
      return {
        ...state,
        activeStep: action.payload,
      };

    case types.UPDATE_INFO_FORM_FIELD:
      return {
        ...state,
        fetchInfoForm: {
          ...state.fetchInfoForm,
          [action.payload.name]: action.payload.value,
        },
      };

    case types.UPDATE_FETCHED_USER_INFO:
      return {
        ...state,
        fetchedUser: {
          ...state.fetchedUser,
          [action.payload.name]: action.payload.value,
        },
      };

    case types.FETCH_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        fetchedCompany: action.payload,
      };

    case types.SAVE_APPLICATION_REGISTER_POA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.UPDATE_POA_SOURCE:
      return {
        ...state,
        poaSource: action.payload,
        fetchedPOADetails: {},
        poaDetailsFormFields: {
          poaNumber: '',
        },
        documents: [],
      };

    case types.FETCH_POA_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        fetchedPOADetails: action.payload,
        poaDetailsFormFields: {
          ...state.poaDetailsFormFields,
          poaNumber: action?.payload?.poaDetails?.documentNumber,
        },
      };

    case types.UPDATE_POA_DETAILS_FIELDS:
      return {
        ...state,
        poaDetailsFormFields: {
          ...state.poaDetailsFormFields,
          ...action.payload,
        },
      };

    case types.FETCH_POA_CONTRACT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        ...action.payload,
      };

    case types.FETCH_MULTI_PROPERTIES_SUCCESS:
      return {
        ...state,
        multiProperties: action.payload,
      };

    case types.REGISTER_POA_FETCH_LOOKUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        lookups: {
          ...state.lookups,
          ...action.payload,
        },
      };
    case types.FETCH_COUNTRIES_SUCCESS:
      return {
        ...state,
        loading: false,
        lookups: {
          ...state.lookups,
          countries: action.payload,
        },
      };
    case types.FETCH_CITIES_SUCCESS:
      return {
        ...state,
        loading: false,
        lookups: {
          ...state.lookups,
          cities: action.payload,
        },
      };

    case types.ADD_ENTITY_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case types.FETCH_SINGLE_PROPERTY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        singlePropertyDetails: get(action.payload, 'property', {}),
      };

    case types.TERMINATE_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case types.DELETE_PARTY_SUCCESS:
      return {
        ...state,
        loading: false,
        ...action.payload,
      };

    default:
      return state;
  }
}
